import type { ApplicableTemplate } from '../../types/contracts';

/** Where the member stands on the Membership Agreement, which comes before any Series
 *  contract. Null once it is approved (or there is no onboarding document to sign). */
export function membershipNote(items: readonly ApplicableTemplate[]): string | null {
  const general = items.filter((it) => it.scope === 'general');
  if (general.some((it) => it.case_state === null)) {
    return 'Start with the Membership Agreement. Your series contracts come after it.';
  }
  const inProgress = general.some(
    (it) => it.case_state !== 'approved' && it.case_state !== 'rejected',
  );
  return inProgress
    ? 'We review one agreement at a time. Your series contracts can start as soon as your Membership Agreement is complete.'
    : null;
}
